export const VOTE_STATUS_CONFIG = [
  {
    label: 'Đồng ý',
    color: 'green',
    value: 1,
  },
  {
    label: 'Không đồng ý',
    color: 'red',
    value: 0,
  },
  {
    label: 'Không ý kiến',
    color: 'default',
    value: 2,
  },
  {
    label: 'Chưa cho ý kiến',
    color: 'gold',
    value: null,
  },
]
